export function getGuid() {
    let guid: string;
    const crypto = window.crypto;
    if (crypto?.randomUUID) {
        guid = crypto.randomUUID();
    } else {
        const s4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        guid = (s4() + s4() + '-' + s4() + '-4' + s4().substr(0, 3) + '-' + s4() + '-' + s4() + s4() + s4()).toLowerCase();
    }
    return guid;
}